export const BALLOON_TERM_TYPE_TOOLTIP_CONTENT = (
    <>
        <strong>Term:</strong> Last monthly payment and balloon amount are due on the date of the last monthly payment.
        <br />
        <br />
        <strong>Term-1:</strong> The balloon amount is due on the day of the last monthly payment. The last monthly payment ends one
        month early so this term selection will have a higher monthly payment.
    </>
);
